"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const strings_1 = require("../../../assets/strings/strings");
const validations_1 = require("../../../utils/validations");
const auth_requests_1 = require("../../../dataSource/auth_requests");
const response_codes_1 = require("../../../assets/constants/response_codes");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const constants_1 = require("../../../assets/constants/constants");
require("./ModalPortalInvestidor.scss");
const ModalPortalInvestidor = ({ visible, setIsVisible }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [formLogin] = antd_1.Form.useForm();
    const [formForgotPassword] = antd_1.Form.useForm();
    const [showForgotPassword, setShowForgotPassword] = (0, react_1.useState)(false);
    const [emailSent, setEmailSent] = (0, react_1.useState)('');
    const handleHideShowForgot = () => setShowForgotPassword(false);
    const handleShowForgot = () => setShowForgotPassword(true);
    (0, react_1.useEffect)(() => {
        formLogin.resetFields();
        formForgotPassword.resetFields();
        setEmailSent('');
        if (!visible)
            handleHideShowForgot();
    }, [visible]);
    const handleLoginResponse = (0, react_1.useCallback)((response) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(false);
        if (!response.status) {
            window.location.href = `${constants_1.PORTAL_FRONT_URL}/login-portal/${response.jwtToken}`;
        }
        else {
            switch (response.status) {
                case response_codes_1.PortalLoginCodes.error.INVALID_ACCOUNT:
                    message_utils_1.default.error({
                        message: strings_1.PortalLoginMessages.message.invalidAccount,
                        description: strings_1.PortalLoginMessages.description.invalidAccount,
                    });
                    break;
                case response_codes_1.PortalLoginCodes.error.USER_NOT_FOUND:
                    message_utils_1.default.error({
                        message: strings_1.PortalLoginMessages.message.userNotFound,
                        description: strings_1.PortalLoginMessages.description.userNotFound,
                    });
                    break;
                default:
                    message_utils_1.default.error();
                    break;
            }
        }
    }), [history]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const username = formLogin.getFieldValue('username');
        const password = formLogin.getFieldValue('password');
        const response = yield (0, auth_requests_1.portalAuthenticate)({
            username,
            password,
        });
        handleLoginResponse(response);
    }), [formLogin, handleLoginResponse]);
    const handleCancel = () => setIsVisible(false);
    const handleSubmitForgotPassword = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const email = formForgotPassword.getFieldValue('email').toLowerCase();
        setLoading(true);
        const response = yield (0, auth_requests_1.portalForgotPassword)({ email });
        setLoading(false);
        switch (response.status) {
            case response_codes_1.ForgotPasswordPortalInvestidorCodes.SUCCESS:
                message_utils_1.default.success({
                    message: strings_1.ForgotPasswordMessages.verifyYourEmail,
                    description: strings_1.ForgotPasswordMessages.instructionsSent,
                });
                setEmailSent(email);
                break;
            case response_codes_1.ForgotPasswordPortalInvestidorCodes.error.USER_NOT_FOUND:
                message_utils_1.default.error({
                    message: strings_1.ForgotPasswordMessages.userNotFound,
                    description: strings_1.ForgotPasswordMessages.verifyAndTryAgain,
                });
                break;
            default:
                message_utils_1.default.error({
                    description: strings_1.ForgotPasswordMessages.verifyAndTryAgain,
                });
                break;
        }
    }), [formForgotPassword]);
    return (react_1.default.createElement(antd_1.Modal, { wrapClassName: "login-modal", maskClosable: false, visible: visible, onCancel: handleCancel, footer: [] }, !showForgotPassword ? (react_1.default.createElement("div", { className: "modal-content" },
        react_1.default.createElement("div", { className: "modal-head" },
            react_1.default.createElement("h1", { className: "modal-title" }, "Acesse o seu"),
            react_1.default.createElement("h1", { className: "modal-title" }, "portal!"),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: "modal-description" }, "Bem-vindo ao 360 Su\u00EDtes Propriet\u00E1rios")),
        react_1.default.createElement("div", { className: "login-content" },
            react_1.default.createElement("h2", null, "E-mail de acesso"),
            react_1.default.createElement(antd_1.Form, { form: formLogin, onFinish: () => handleSubmit(), noValidate: true },
                react_1.default.createElement(antd_1.Form.Item, { name: "username", rules: [
                        {
                            required: true,
                            message: strings_1.FieldsMessages.email.insertYourEmail,
                        },
                        {
                            type: 'email',
                            message: strings_1.FieldsMessages.email.invalidEmailFormat,
                        },
                        {
                            pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                            message: strings_1.FieldsMessages.email.dontUseSpecialCharacters,
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input, { className: "input-field", type: "email", placeholder: "digite aqui seu e-mail de acesso" })),
                react_1.default.createElement(antd_1.Form.Item, { name: "password", rules: (0, validations_1.fieldPasswordRules)() },
                    react_1.default.createElement(antd_1.Input, { className: "input-field", type: "password", placeholder: "Digite aqui sua senha" })),
                react_1.default.createElement(antd_1.Form.Item, null,
                    react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-login", loading: isLoading }, "Continuar"))),
            react_1.default.createElement("div", { className: "forgot-password-login-portal" },
                react_1.default.createElement("a", { onClick: handleShowForgot },
                    react_1.default.createElement("span", null,
                        strings_1.LoginPageMessages.login.forgotPasswordPortal,
                        " ")))))) : (react_1.default.createElement("div", { className: "forgot-password-content" },
        react_1.default.createElement("div", { className: "form-container" },
            react_1.default.createElement("div", { className: "forgot-header" },
                react_1.default.createElement("span", null, "Recuperar "),
                "minha senha"),
            react_1.default.createElement("div", { className: "forgot-message" },
                react_1.default.createElement("span", null, "Esqueceu sua senha?"),
                react_1.default.createElement("br", null),
                "N\u00E3o se preocupe. \u00C9 s\u00F3 nos dizer seu e-mail que enviaremos um c\u00F3digo de acesso para voc\u00EA cadastrar uma nova senha."),
            !emailSent ? (react_1.default.createElement(antd_1.Form, { form: formForgotPassword, className: "forgot-form", onFinish: () => handleSubmitForgotPassword(), noValidate: true },
                react_1.default.createElement(antd_1.Form.Item, { name: "email", rules: [
                        {
                            required: true,
                            message: strings_1.FieldsMessages.email.insertYourEmail,
                        },
                        {
                            type: 'email',
                            message: strings_1.FieldsMessages.email.invalidEmailFormat,
                        },
                        {
                            pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                            message: strings_1.FieldsMessages.email.dontUseSpecialCharacters,
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input, { className: "input-field", type: "email", placeholder: "E-mail" })),
                react_1.default.createElement(antd_1.Form.Item, null,
                    react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-forgot", loading: isLoading }, strings_1.ForgotPasswordMessages.confirm)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "success-message" },
                    "As instru\u00E7\u00F5es para cadastrar uma nova senha foram enviadas para o e-mail",
                    react_1.default.createElement("span", null,
                        " ",
                        emailSent)))),
            react_1.default.createElement("div", { className: "forgot-footer" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("span", null, "\u00A0"),
                    react_1.default.createElement("a", { onClick: handleHideShowForgot }, strings_1.ForgotPasswordMessages.backToLoginPortal))))))));
};
exports.default = ModalPortalInvestidor;
